import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { useOrganizationSettingsStore } from '../../../store/organizationSettingsStore';
import { ORGANIZATION_SETTINGS } from '../../../constants/pageIdentifiers';

export const useSendFacebookCode = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation(
    (code: string) => dataFetch.post(
      `${DIGGER_API_SUFFIX}facebook/initiate`,
      {
        code,
      },
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(ORGANIZATION_SETTINGS);
      },
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};

export const useDisconnectFacebook = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { organizationSettings, setOrganizationSettings } = useOrganizationSettingsStore();

  return useMutation<ApiResponse<null>, ApiError<null>>(
    () => dataFetch.patch(
      `${CORE_API_SUFFIX}organization-settings/facebook/uninstall`,
    ),
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('disconnectedSuccess'), 'success');
        setOrganizationSettings({
          ...organizationSettings,
          facebookToken: undefined,
          facebookCustomerId: undefined,
        });
        queryClient.invalidateQueries(ORGANIZATION_SETTINGS);
      },
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};
